module.exports = {
	"name": "Adventura",
	"foodRecommendations": [
		{
			"text": "The papas bravas and the stuffed dates are amazing.",
			"person": "Charlie Ruiz"
		},
		{
			"text": "They have a really good happy hour and good sangria.",
			"person": "Marisa Iaderosa"
		}
	],
	"address": "216 E Washington St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.280268,
		"lng": -83.746478
	},
	"catImage": "greenstar.png",
	"totalCats": 1,
	"totalMisc": 0,
	"categories": {
		"location": 1,
		"fooddrink": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/adventura.json
// module id = 800
// module chunks = 0